import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { TestIds } from '@/constants/testIds';

export const CommonQuestions = () => {
  const { t } = useTranslation();
  const questions = [
    {
      questionKey: 'landing.commonQuestions.q1.question',
      answerKey: 'landing.commonQuestions.q1.answer',
    },
    {
      questionKey: 'landing.commonQuestions.q2.question',
      answerKey: 'landing.commonQuestions.q2.answer',
    },
    {
      questionKey: 'landing.commonQuestions.q3.question',
      answerKey: 'landing.commonQuestions.q3.answer',
    },
  ];

  return (
    <div className="w-full bg-[#F9FAFB] px-6 md:px-8 py-16">
      <div className="bg-white rounded-lg p-6">
        {/* Title */}
        <h2
          data-testid={TestIds.faq.title}
          className="text-2xl md:text-3xl font-bold mb-6"
        >
          {t('landing.commonQuestions.title')}
        </h2>

        {/* Accordion */}
        <Accordion type="single" collapsible className="w-full">
          {questions.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className={index === questions.length - 1 ? 'border-b-0' : ''}
            >
              <AccordionTrigger
                data-testid={TestIds.faq.trigger(index)}
                className="text-left"
              >
                {t(item.questionKey)}
              </AccordionTrigger>
              <AccordionContent
                data-testid={TestIds.faq.content(index)}
                className="text-muted-foreground"
              >
                {t(item.answerKey)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};
